import {
  fetchAllCountriesList,
  fetchGetVerifyCodeByEmail,
  fetchCheckVerifyCode,
  fetchResetPassword,
  fetchLanguageList,
} from '@/api/base'

// 获取验证码倒计时限制
const countdownTime = 60
const base = {
  namespaced: true,
  state: {
    allCountriesList: [],
    countdown: countdownTime,
    countdownTime,
    languageList: [],
  },

  mutations: {
    SET_ALL_COUNTRIES_LIST: (state, allCountriesList) => {
      state.allCountriesList = allCountriesList
    },
    SET_COUNT_DOWN: (state, countdown) => {
      state.countdown = countdown
    },
    SET_LANGUAGE_LIST: (state, languageList) => {
      state.languageList = languageList
    },
  },

  actions: {
    // 获取国家列表
    GetCountriesList({ commit }) {
      return fetchAllCountriesList().then((res) => {
        commit('SET_ALL_COUNTRIES_LIST', res)
      })
    },
    // 获取语言列表
    GetLanguageList({ commit }) {
      return fetchLanguageList().then((res) => {
        commit('SET_LANGUAGE_LIST', res)
      })
    },
    // 获取验证码（邮箱）
    GetVerifyCodeByEmail({ state, dispatch }, loginEmail) {
      if (state.countdown === countdownTime) {
        return fetchGetVerifyCodeByEmail({ loginEmail }).then(() => {
          dispatch('VerifyCodeCountDown')
        })
      }
    },
    // 获取验证码倒计时
    VerifyCodeCountDown({ state }) {
      state.countdown--
      const countingDown = setInterval(() => {
        state.countdown--
        if (state.countdown === 0) {
          state.countdown = countdownTime
          clearInterval(countingDown)
        }
      }, 1000)
    },
    // 验证码校验
    CheckVerifyCode({ commit }, formList) {
      formList.verifyCode = formList.verifyCode.toLowerCase()
      return fetchCheckVerifyCode(formList).then(() => {
        commit('user/SET_LOGINEMAIL', formList.loginEmail, { root: true })
      })
    },
    // 确认修改密码
    ResetPassword({ rootState }, formList) {
      return fetchResetPassword({
        ...formList,
        loginEmail: rootState.user.loginEmail,
      })
    },
  },
}

export default base
